import { Link } from 'react-router-dom';
import { getRole } from './api';
import { t } from './i18n';

/**
 * The address nobody meant to type — an old push payload, a mistyped link.
 * Sends each role back to its own front door rather than stranding them on a
 * blank router error.
 */
export function NotFound() {
  const role = getRole();
  const home = role === 'staff' ? '/today' : role === 'owner' ? '/home' : '/';
  return (
    <div className="app-shell items-center justify-center px-6 text-center">
      <p className="text-sm font-bold text-muted-foreground">404</p>
      <h1 className="page-title mt-2">{t('This page does not exist')}</h1>
      <p className="page-subtitle">{t('The link may be old or mistyped.')}</p>
      <Link to={home} className="btn-primary btn-block mt-6 sm:w-auto">
        {t('Back to home')}
      </Link>
    </div>
  );
}
